import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { MessageType, UserChatHistoryType } from "../utils/types";

// get chat history
export const createChatHistory = async (
  chatId: string,
  userId: string | undefined
) => {
  if (!userId) return [];
  const userChatCollection = query(
    collection(db, "userChatRecords"),
    where("userId", "==", userId),
    where("chatId", "==", chatId)
  );
  const userChatSnapshot = await getDocs(userChatCollection);
  let chatHistory = userChatSnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
    lastRead: new Date(doc.data().lastRead),
  })) as UserChatHistoryType[];

  //if there is no chatHistory yet, let's add one
  const lastReadDate = new Date();
  if (chatHistory.length === 0) {
    const docRef = await addDoc(collection(db, "userChatRecords"), {
      chatId: chatId,
      userId: userId,
      lastRead: lastReadDate.toISOString(),
    });
  }
};

// get chat history
export const fetchChatHistory = async (
  chatId: string,
  userId: string | undefined,
  setChatHistory: any
) => {
  if (!userId) {
    setChatHistory([]);
    return;
  }
  const userChatCollection = query(
    collection(db, "userChatRecords"),
    where("userId", "==", userId),
    where("chatId", "==", chatId)
  );
  const userChatSnapshot = await getDocs(userChatCollection);
  let chatHistory = userChatSnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
    lastRead: new Date(doc.data().lastRead),
  })) as UserChatHistoryType[];

  setChatHistory(chatHistory);
};

// update chat history
// get chat history
export const updateChatHistory = async (
  chatId: string,
  userId: string | undefined,
  id: string
) => {
  // update name in the firestore
  const lastReadDate = new Date();
  const docRef = doc(db, "userChatRecords", id);
  await updateDoc(docRef, {
    lastRead: lastReadDate.toISOString(),
    chatId: chatId,
    userId: userId,
  });
};

// get chat history
export const checkUnreadMessages = async (
  userId: string | undefined,
  loggedInUserId: string | undefined
) => {
  if (!loggedInUserId) return false;
  // check if logged in user has any messages in the chat with other user
  const messagesCollection = query(
    collection(db, "messages"),
    where("recipientId", "==", loggedInUserId),
    where("senderId", "==", userId)
  );
  const messagesSnapshot = await getDocs(messagesCollection);
  const messages = messagesSnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
    createdAt: new Date(doc.data().createdAt),
  })) as MessageType[];
  if (messages.length === 0) {
    return false;
    return;
  }

  // user has messages, let's get when user last time saw messages
  const chatId = getChatId(userId, loggedInUserId);
  const userChatCollection = query(
    collection(db, "userChatRecords"),
    where("userId", "==", loggedInUserId),
    where("chatId", "==", chatId)
  );
  const userChatSnapshot = await getDocs(userChatCollection);
  const chatHistory = userChatSnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
    lastRead: new Date(doc.data().lastRead),
  })) as UserChatHistoryType[];

  // no chat history
  if (chatHistory.length === 0) {
    return true;
    return;
  }

  const lastReadDate = new Date(chatHistory[0].lastRead);
  let sortedMessages = messages.sort(createdDateSort);
  if (sortedMessages[0].createdAt > lastReadDate) {
    return true;
  } else {
    return false;
  }
};

const createdDateSort = (a: MessageType, b: MessageType) => {
  if (a.createdAt > b.createdAt) return -1;
  if (a.createdAt < b.createdAt) return 1;
  return 0;
};

export const getChatId = (
  userId1: string | undefined,
  userId2: string | undefined
) => {
  const users = [userId1 ?? "", userId2 ?? ""];
  const chatId = users.sort((a, b) => a.localeCompare(b)).join("");
  return chatId;
};
